var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(_vm.express)?_c('v-icon',_vm._g({staticClass:"pl-1",attrs:{"small":_vm.small,"color":"warning"}},on),[_vm._v("fas fa-shipping-fast")]):_vm._e()]}}])},[_c('span',[_vm._v("Box express")])])}
var staticRenderFns = []

export { render, staticRenderFns }